import { type IAvailability, type IDropdownItem } from "@ryde/shared";

import { MAX_DISPLAY_ITEMS } from "./availability-cell.constants";
import { formatTimeRange } from "./availability-cell.helpers";
import { type IExpandedAvailability } from "./availability-cell.models";

const getMatchingLabels = (
  ids: number[] | undefined,
  items: IDropdownItem[] | undefined,
): string[] => {
  if (!ids?.length || !items?.length) {
    return [];
  }

  const idsSet = new Set(ids);

  return items.filter(di => idsSet.has(+di.value)).map(di => di.label);
};

export const expandAvailabilityItem = ({
  item,
  dayTypeItems,
  dayGroupItems,
}: {
  item: IAvailability;
  dayTypeItems: IDropdownItem[] | undefined;
  dayGroupItems: IDropdownItem[] | undefined;
}): IExpandedAvailability => ({
  ...item,
  dayTypeNamesList: getMatchingLabels(item.dayTypeIds, dayTypeItems),
  dayGroupNamesList: getMatchingLabels(item.dayGroupIds, dayGroupItems),
});

export const generateDisplayText = (
  values: IExpandedAvailability[],
  timeFormat: string,
): string => {
  const labels = values.map(val =>
    [
      formatTimeRange({ from: val.from, to: val.to, timeFormat }),
      ...val.dayGroupNamesList,
      ...val.dayTypeNamesList,
    ]
      .filter(Boolean)
      .join(", "),
  );

  return labels.slice(0, MAX_DISPLAY_ITEMS).join(", ");
};

export const calculateMoreItemsCount = (total: number): number =>
  total > MAX_DISPLAY_ITEMS ? total - MAX_DISPLAY_ITEMS : 0;
